import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  root: {
    background: "#fff",
    color: "#000",
    boxShadow: "none",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px",
    // paddingLeft: "250px !important",
    //
    [theme.breakpoints.down("md")]: {
      paddingLeft: "0 !important",
      padding: "10px !important",
    },
    // zIndex: 999,
    zIndex: 10,
  },
  appBarInnerMainBox: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    gap: "30px",
  },
  appBarLogoBox: {
    transition: "all 0.3s ease-in-out",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    marginLeft: "10px",
    // Responsive display
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    [theme.breakpoints.up("md")]: {
      display: "flex", // or "block", depending on your desired layout
    },
  },
  //
  logoImage: {
    transition: "opacity 0.3s ease-in-out",
    opacity: 0,
    pointerEvents: "none",
  },

  logoVisible: {
    opacity: 1,
    pointerEvents: "auto",
  },

  logoVisibleDelayed: {
    opacity: 1,
    transition: "opacity 0.2s ease-in-out 0.1s", // Wait 0.1s then fade in over 0.2s
    pointerEvents: "auto",
  },

  logoHidden: {
    opacity: 0,
    pointerEvents: "none",
  },
  //
  appBarContentBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  appBarRightContent: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "25px",
  },
  profileBox: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    cursor: "pointer",
  },
  appBarContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "5px",
  },
  profileUserName: {
    fontFamily: "Poppins, sans-serif",
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "100%",
    letterSpacing: "0px",
    color: "#404040",
    whiteSpace: "nowrap",
  },
  profileUserRole: {
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "100%",
    letterSpacing: "0px",
    color: "#565656",
  },
  // heading
  headBox: {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
  },
  heading: {
    fontFamily: "Poppins",
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: "100%",
    [theme.breakpoints.down("md")]: {
      fontSize: "25px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "22px",
    },
  },
  subtext: {
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "16px",
    [theme.breakpoints.down("md")]: {
      fontSize: "15px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
      display: "none",
    },
  },
}));
export default useStyles;
